export default __webpack_public_path__ + "static/media/twitter_logo_white_outlined.683387d3.svg";